import { useState, useEffect, useCallback } from 'react';
import axiosInstance from 'utils/axiosInterceptors';
import { TLocations, IResponseGetter } from 'utils/types';

interface LocationsResponse {
  data: TLocations[];
  pageCount: number;
}

const useGetLocations = ({
  branchDomain,
  currentPage,
  pageSize,
  orderBy,
  orderByDesc,
  searchTerm
}: IResponseGetter) => {
  const [locations, setLocations] = useState<TLocations[]>([]);
  const [pageCount, setPageCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchLocation = useCallback(async () => {
    if (!branchDomain) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get<LocationsResponse>(
        `/api/v1/${branchDomain}/locations?page=1&pageSize=${pageSize}`
      );
      setLocations(response.data.data);
      setPageCount(response.data.pageCount);
    } catch (err) {
      setError('Failed to fetch locations');
    } finally {
      setLoading(false);
    }
  }, [branchDomain, currentPage, pageSize, orderBy, orderByDesc, searchTerm]);

  useEffect(() => {
    fetchLocation();
  }, [fetchLocation]);

  return { locations, pageCount, loading, error, refetch: fetchLocation };
};

export default useGetLocations;
